import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CompleteMedicalCareStruct } from 'src/app/shared/services/structs/orchestrator-patient/complete-medical-care.struct';
import { MatDialog } from '@angular/material/dialog';
import { ListMedicineResponse } from 'src/app/shared/services/responses/pharmacy/list-medicine.response';
import { SadtModalComponent } from 'src/app/shared/components/sadt-modal/sadt-modal.component';
import { LookupMedicalCareResponse } from 'src/app/shared/services/responses/medical-record/lookup-medical-care-response';
import { ReadExternalPrescriptionStruct } from 'src/app/shared/services/structs/orchestrator-patient/read-external-prescription.struct';
import { ExamTypeModel } from 'src/app/shared/services/models/SADT/exam-type.model';
import { MedicalProcedureStruct } from 'src/app/shared/services/structs/medical-record/medical-procedure.struct';
import { ExternalPrescriptionModalComponent } from 'src/app/shared/components/external-prescription-modal/external-prescription-modal.component';
import { MedicalCareSadtStruct } from 'src/app/shared/services/structs/medical-record/medical-care-sadt.struct';
import { PrescriptionStatusEnum } from 'src/app/shared/enum/prescription-status.enum';
import { PrescriptionsSuspensionModalComponent } from 'src/app/shared/components/prescriptions-suspension-modal/prescriptions-suspension-modal.component';
import { ExamsSuspensionModalComponent } from 'src/app/shared/components/exams-suspension-modal/exams-suspension-modal.component';
import { SadtStatusEnum } from 'src/app/shared/enum/sadt-status.enum';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionModalComponent } from 'src/app/shared/components/prescription-modal/prescription-modal.component';
import { AuxStandardPrescriptionStruct } from 'src/app/shared/services/structs/pharmacy/aux-standard-prescription.struct';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';
import { MedicineTagUtilsService } from 'src/app/shared/services/medicine-tag-utils.service';
import { MedicalProcedureModalComponent } from 'src/app/medic/pages/attend-patient/medical-procedure-modal/medical-procedure-modal.component';
import { ExamTypeService } from '../../services/API/SADT/exam-type.service';
import { MedicineService } from '../../services/API/pharmacy/medicine.service';
import { LookupMedicalCareService } from '../../services/API/medical-record/lookup-medical-care.service';
import { AlertService, AlertType } from '../../services/alert.service';
import { PrescriptionNonStandard } from '../../services/models/pharmacy/prescription-non-standard.model';
import { PrescriptionNonStandardModalComponent } from '../prescription-non-standard-modal/prescription-non-standard-modal.component';
import { LookupsBooleanChoiceRequest } from '../../services/requests/pharmacy/lookups-boolean-choice.request';
import { PharmacyLookupService } from '../../services/API/pharmacy/pharmacy-lookup.service';
import { DilutionUnit } from '../../services/models/pharmacy/dilution-unit.model';
import { Dilution } from '../../services/models/pharmacy/dilution.model';
import { DoseToAdministered } from '../../services/models/pharmacy/dose-to-administered.model';
import { Frequency } from '../../services/models/pharmacy/frequency.model';
import { MeasurementUnit } from '../../services/models/pharmacy/measurement-unit.model';
import { MedicineAdministrationTypeModel } from '../../services/models/pharmacy/medicine-administration-type.model';
import { MedicinePresentationTypeModel } from '../../services/models/pharmacy/medicine-presentation-type.model';
import { SubFrequency } from '../../services/models/pharmacy/sub-frequency.model';
import { TreatmentPeriod } from '../../services/models/pharmacy/treatment-period.model';
import { Usage } from '../../services/models/pharmacy/usage.model';

@Component({
    selector: 'app-medical-care-accordion',
    templateUrl: './medical-care-accordion.component.html',
    styleUrls: ['./medical-care-accordion.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MedicalCareAccordionComponent implements OnInit {

  constructor(private dialog: MatDialog,
    private alertService: AlertService,
    private examTypeService: ExamTypeService,
    public medicineService: MedicineService,
    public lookupMedicalCareService: LookupMedicalCareService,
    public medicineTagUtilsService: MedicineTagUtilsService,
    private pharmacyLookupService: PharmacyLookupService,
  ) { }

  @Input() medicalCare: CompleteMedicalCareStruct[] = [];
  @Input() lookupMedicalCareResponse: LookupMedicalCareResponse;
  @Input() listMedicine: ListMedicineResponse;
  @Input() listExam: ExamTypeModel[];
  @Input() listMedicinePresentationType: MedicinePresentationTypeModel[] = [];
  @Input() listDilution: Dilution[] = [];
  @Input() listMeasurementUnit: MeasurementUnit[] = [];
  @Input() listMedicineAdministrationType: MedicineAdministrationTypeModel[] = [];
  @Input() listDoseToAdministered: DoseToAdministered[] = [];
  @Input() listDilutionUnit: DilutionUnit[] = [];
  @Input() listFrequency: Frequency[] = [];
  @Input() listSubFrequency: SubFrequency[] = [];
  @Input() listTreatmentPeriod: TreatmentPeriod[] = [];
  @Input() listUsage: Usage[] = [];

  public prescriptionStatusEnum: typeof PrescriptionStatusEnum = PrescriptionStatusEnum;
  public sadtStatusEnum: typeof SadtStatusEnum = SadtStatusEnum;

  ngOnInit(): void {
    if (!this.listMedicinePresentationType || !this.listDilution || !this.listMeasurementUnit || !this.listMedicineAdministrationType || !this.listDoseToAdministered ||
      !this.listDilutionUnit || !this.listFrequency || !this.listSubFrequency || !this.listTreatmentPeriod || !this.listUsage)
      this.populatePharmacyLookups();
    if (!this.listMedicine)
      this.getLookupMedicine();
    if (!this.listExam)
      this.getLookupSadtType();
  }

  getLookupMedicine() {
    this.medicineService.listAllMedicine(true).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listMedicine = response;
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getLookupSadtType() {
    this.examTypeService.listAllExamTypeWithExams().subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listExam = response.listExamType;
      }
    });
  }

  openPrecriptionModalWithMedicine(prescriptionMedicine: PrescriptionMedicineStruct) {
    let prescription = new AuxStandardPrescriptionStruct();
    prescription.prescriptionMedicineStruct = prescriptionMedicine;
    this.openPrescriptionModal(prescription, false);
  }

  openPrecriptionModalWithMedicatedSolution(prescriptionSolution: PrescriptionSolutionStruct) {
    let prescription = new AuxStandardPrescriptionStruct();
    prescription.prescriptionSolutionStruct = prescriptionSolution;
    this.openPrescriptionModal(prescription, true);
  }

  openPrescriptionModal(prescription: AuxStandardPrescriptionStruct, isMedicatedSolution: boolean) {
    const dialogRef = this.dialog.open(PrescriptionModalComponent, {
      data: {
        prescription,
        readOnly: true,
        lookupMedicalCareResponse: this.lookupMedicalCareResponse,
        listMedicine: this.listMedicine,
        isMedicatedSolution: isMedicatedSolution,
        listMedicinePresentationType: this.listMedicinePresentationType,
        listDilution: this.listDilution,
        listMeasurementUnit: this.listMeasurementUnit,
        listMedicineAdministrationType: this.listMedicineAdministrationType,
        listDoseToAdministered: this.listDoseToAdministered,
        listDilutionUnit: this.listDilutionUnit,
        listFrequency: this.listFrequency,
        listSubFrequency: this.listSubFrequency,
        listTreatmentPeriod: this.listTreatmentPeriod,
        listUsage: this.listUsage,
      },
    });
  }

  openProcedureModal(procedure: MedicalProcedureStruct) {
    const dialogRef = this.dialog.open(MedicalProcedureModalComponent, {
      data: {
        procedure: procedure,
        idMedicalProcedure: procedure.idMedicalProcedure,
      },
    });
  }

  openExternalPrescriptionModal(prescription: ReadExternalPrescriptionStruct) {
    const dialogRef = this.dialog.open(ExternalPrescriptionModalComponent, {
      data: {
        prescription,
        readOnly: true,
      },
    });
  }

  openPrescriptionNonStandardModal(prescription: PrescriptionNonStandard) {
    const dialogRef = this.dialog.open(PrescriptionNonStandardModalComponent, {
      data: {
        prescription,
        readOnly: true,
      },
    });
  }

  openSadtModal(sadt: MedicalCareSadtStruct, readOnly: boolean) {
    const dialogRef = this.dialog.open(SadtModalComponent, {
      data: {
        sadt,
        readOnly: true,
        listPlace: this.lookupMedicalCareResponse.listPlace,
        listExamType: this.listExam,
        listSadtSchedule: this.lookupMedicalCareResponse.listSadtSchedule,
      },
    });
  }

  openPrescriptionsSuspensionModal(idCurrentMedicalCare: number) {
    this.dialog.open(PrescriptionsSuspensionModalComponent, {
      data: {
        medicalCare: this.medicalCare,
        isHistory: true,
        idCurrentMedicalCare: idCurrentMedicalCare,
      },
      panelClass: "prescriptions-suspension"
    });
  }

  openExamsSuspensionModal(idCurrentMedicalCare: number) {
    this.dialog.open(ExamsSuspensionModalComponent, {
      data: {
        medicalCare: this.medicalCare,
        isHistory: true,
        idCurrentMedicalCare: idCurrentMedicalCare,
      },
      panelClass: "prescriptions-suspension"
    });
  }

  populatePharmacyLookups() {
    let request: LookupsBooleanChoiceRequest = new LookupsBooleanChoiceRequest();
    request.isToGetMedicinePresentationTypeLookup = true;
    request.isToGetMedicineAdministrationTypeLookup = true;
    request.isToGetDilution = true;
    request.isToGetDilutionUnit = true;
    request.isToGetFrequency = true;
    request.isToGetSubFrequency = true;
    request.isToGetMeasurementUnitLookup = true;
    request.isToGetDoseToAdministered = true;
    request.isToGetTreatmentPeriod = true;
    request.isToGetUsage = true;

    this.pharmacyLookupService.searchLookupsUsingBooleanRequestFilter(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.listMedicinePresentationType = [];
        if (response.listMedicinePresentationType && response.listMedicinePresentationType.length > 0)
          this.listMedicinePresentationType = [...response.listMedicinePresentationType];

        this.listMedicineAdministrationType = [];
        if (response.listMedicineAdministrationType && response.listMedicineAdministrationType.length > 0)
          this.listMedicineAdministrationType = [...response.listMedicineAdministrationType];

        this.listDilution = [];
        if (response.listDilution && response.listDilution.length > 0)
          this.listDilution = [...response.listDilution];

        this.listMeasurementUnit = [];
        if (response.listMeasurementUnit && response.listMeasurementUnit.length > 0)
          this.listMeasurementUnit = [...response.listMeasurementUnit];

        this.listDilutionUnit = [];
        if (response.listDilutionUnit && response.listDilutionUnit.length > 0)
          this.listDilutionUnit = [...response.listDilutionUnit];

        this.listFrequency = [];
        if (response.listFrequency && response.listFrequency.length > 0)
          this.listFrequency = [...response.listFrequency];

        this.listSubFrequency = [];
        if (response.listSubFrequency && response.listSubFrequency.length > 0)
          this.listSubFrequency = [...response.listSubFrequency];

        this.listTreatmentPeriod = [];
        if (response.listTreatmentPeriod && response.listTreatmentPeriod.length > 0)
          this.listTreatmentPeriod = [...response.listTreatmentPeriod];

        this.listUsage = [];
        if (response.listUsage && response.listUsage.length > 0)
          this.listUsage = [...response.listUsage];
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }
}